module.exports = __webpack_public_path__ + "media/images/sp/page_common/banner/banner_costumes-d87ddc816a544e27e09590423eee7fa6.jpg";